import { authFetch } from '../utils/authFetch';
import { baseUrl } from '../utils/requestUrl';

export const createFunctionalChecklist = async (checklistData) => {
    const response = await authFetch(`${baseUrl}/checklists`, {
        method: 'POST',
        body: JSON.stringify(checklistData),
    });
    
    return response.json();
}; 

export const fetchFunctionalChecklist = async (pageNumber = 1, pageSize = 10) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const organizationId = user?.organizations?.[0]?.id;
    const response = await authFetch(
        `${baseUrl}/checklists/organization/${organizationId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return response.json();
};

export const searchFunctionalChecklists = async (name = "", pageNumber = 1, pageSize = 5) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const organizationId = user?.organizations?.[0]?.id;
    const response = await authFetch(
        `${baseUrl}/checklists/organization/${organizationId}?pageNumber=${pageNumber}&pageSize=${pageSize}&name=${name}`
    );
    return response.json();
};